import { isDefined } from '@sgme/fp';
import { Button, HStack } from '@sgme/ui';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { ErrorModal } from '@/App/tiles/shared/ErrorModal.tsx';
import { UsertypeGuard } from '@/components/UsertypeGuard.tsx';
import type { IntlMessageId } from '@/types/intl';

type GrowlErrorProps = {
  errorCode: string;
  multipassErrorCode?: string;
  reason: string;
  sessionId?: string;
};

export const GrowlError = (props: GrowlErrorProps) => {
  const { errorCode, sessionId, multipassErrorCode, reason } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenViewSgLog = () => {
    setIsModalOpen(true);
  };

  return (
    <HStack
      verticalAlignment="center"
      horizontalAlignment="full"
      gap="8px"
      className="alert alert-outline-danger p-2 my-2"
    >
      <div className="d-flex align-items-center">
        <i className="icon me-8px">error_outline</i>
        <FormattedMessage id={`error.${errorCode}` as IntlMessageId} />
      </div>

      {isDefined(errorCode) && (
        <UsertypeGuard allow={['Internal Sales', 'Internal Trader']}>
          <Button purpose="primary" color="danger" onClick={handleOpenViewSgLog} data-e2e="show-error-detail-btn">
            <FormattedMessage id="growl.error.viewLog" />
          </Button>
        </UsertypeGuard>
      )}
      <ErrorModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        multipassErrorCode={multipassErrorCode}
        errorCode={errorCode}
        quoteId={sessionId}
        errorDescription={reason}
      />
    </HStack>
  );
};
